export function convertDate(inputDate: string): string {
  const datePartIndex = inputDate.indexOf(', ') + 2;

  const dateSubsting = inputDate.substring(datePartIndex);
  const [day, month, year] = dateSubsting.split('/').map(Number);

  const dayFromated =
    String(day).length === 1 ? String(day).padStart(2, '0') : day;
  const monthFromated =
    String(month).length === 1 ? String(month).padStart(2, '0') : month;

  return `${year}-${monthFromated}-${dayFromated}`;
}
